import { DropdownMenuItem } from '@/shared/components';
import { ActionMenuItemContent } from './ActionMenuItemContent';
import type { ComponentType, SVGProps } from 'react';

interface Props {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  onClick: () => void;
  childrenClassName?: string;
}

export const ActionMenuItem = ({
  icon: Icon,
  label,
  onClick,
  childrenClassName,
}: Props) => (
  <DropdownMenuItem
    showOptionCheckmark={false}
    className="h-[4.8rem] w-full rounded-[1.2rem] cursor-pointer"
    onClick={e => {
      e.stopPropagation();
      onClick();
    }}>
    <ActionMenuItemContent
      className={childrenClassName}
      icon={Icon}
      label={label}
    />
  </DropdownMenuItem>
);
